import { memo, useMemo } from 'react';
import { Clinic } from '../../../models/MedVox/Clinic';
import {
  SelectAllBehavior,
  useClinicSelectAllOptions,
} from '../../../hooks/shared/useClinicSelectAllOptions';
import UISelect from '../../../uikit/UISelect/UISelect';

type ClinicReportSelectProps = {
  clinics: Clinic[];
  value?: string[];
  onChange: (value: string[]) => void;
  titleSelect: string;
  showTags?: boolean;
  selectAllBehavior?: SelectAllBehavior;
};

export const ClinicReportSelect = memo(
  ({
    clinics,
    value = [],
    onChange,
    titleSelect,
    showTags,
    selectAllBehavior = 'clear-filter',
  }: ClinicReportSelectProps) => {
    const { options, displaySelectedClinicIds, normalizeSelectedClinicIds } =
      useClinicSelectAllOptions(clinics, value, selectAllBehavior);

    const clinicOptions = useMemo(
      () =>
        options.map((option) => ({
          id: option.value,
          name: option.label,
        })),
      [options],
    );

    return (
      <UISelect
        showTags={showTags}
        titleSelect={titleSelect}
        option={clinicOptions}
        selected={displaySelectedClinicIds}
        onSelectedChange={(nextValue) =>
          onChange(normalizeSelectedClinicIds(nextValue ?? []))
        }
      />
    );
  },
);

ClinicReportSelect.displayName = 'ClinicReportSelect';

export type { ClinicReportSelectProps };
